module.exports = __webpack_public_path__ + "img/cms-maz.87196fcf.png";